import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router';
import { confirmPasswordReset, getAuth } from 'firebase/auth';
import { app } from '../utils/firebase';
import ActionButton from './ActionButton';
import { FaCheckCircle } from 'react-icons/fa';
import { MdLockReset } from 'react-icons/md';

export default function ResetPassword() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const auth = getAuth(app);

    const oobCode = searchParams.get('oobCode');
    const mode = searchParams.get('mode');

    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [status, setStatus] = useState<'idle' | 'submitting' | 'done' | 'error'>('idle');
    const [errorMsg, setErrorMsg] = useState('');

    if (!oobCode || mode !== 'resetPassword') {
        return (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
                <p style={{ color: 'red' }}>Invalid or expired password reset link.</p>
            </div>
        );
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setErrorMsg('');

        if (!password) {
            setErrorMsg('Please enter a new password.');
            return;
        }
        if (password !== confirm) {
            setErrorMsg('Passwords do not match.');
            return;
        }
        if (password.length < 6) {
            setErrorMsg('Password must be at least 6 characters.');
            return;
        }

        setStatus('submitting');
        try {
            await confirmPasswordReset(auth, oobCode, password);
            setStatus('done');
        } catch (err: any) {
            let msg = 'Something went wrong. The link may have expired.';
            if (err.code === 'auth/expired-action-code') msg = 'This reset link has expired. Please request a new one.';
            if (err.code === 'auth/invalid-action-code') msg = 'This reset link is invalid or already used.';
            if (err.code === 'auth/weak-password') msg = 'Password is too weak. Use at least 6 characters.';
            setErrorMsg(msg);
            setStatus('idle');
        }
    };

    if (status === 'done') {
        return (
            <div style={{ textAlign: 'center', padding: '2rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
                <FaCheckCircle size={48} style={{ color: '#ffcc00' }} />
                <p>Your password has been reset.</p>
                <ActionButton
                    label="Back to login"
                    onClick={() => navigate('/Login')}
                    icon={<MdLockReset style={{ color: '#ffcc00' }} />}
                    style={{ width: 160, height: 40 }}
                />
            </div>
        );
    }

    return (
        <div style={{ textAlign: 'center', padding: '2rem' }}>
            <p>Set a new password</p>
            <form
                onSubmit={handleSubmit}
                style={{ width: '70vw', display: 'flex', flexDirection: 'column', gap: '15px', margin: '0 auto' }}
            >
                <input
                    type="password"
                    placeholder="New password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="new-password"
                    className="darkInput"
                />
                <input
                    type="password"
                    placeholder="Confirm new password"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    autoComplete="new-password"
                    className="darkInput"
                />
                {errorMsg && (
                    <p style={{ color: 'red', fontSize: '0.9em', margin: '0' }}>{errorMsg}</p>
                )}
                <ActionButton
                    label={status === 'submitting' ? 'Saving...' : 'Set new password'}
                    type="submit"
                    onClick={() => {}}
                    icon={<MdLockReset style={{ color: '#ffcc00' }} />}
                    style={{ width: 180, height: 40 }}
                />
            </form>
        </div>
    );
}
